import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "rcWeekly"
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("異常根因週報")]), _c('div', {
    staticClass: "rc_toolbar"
  }, [_c('label', {
    staticClass: "rc_label"
  }, [_vm._v("資料夾")]), _c('b-form-select', {
    staticClass: "rc_root",
    attrs: {
      "options": _vm.rootOptions,
      "size": "sm",
      "disabled": !_vm.rootOptions.length
    },
    model: {
      value: _vm.root,
      callback: function callback($$v) {
        _vm.root = $$v;
      },
      expression: "root"
    }
  }), _c('label', {
    staticClass: "rc_label"
  }, [_vm._v("期間")]), _c('b-form-select', {
    staticClass: "rc_period",
    attrs: {
      "size": "sm",
      "disabled": !_vm.periods.length
    },
    model: {
      value: _vm.period,
      callback: function callback($$v) {
        _vm.period = $$v;
      },
      expression: "period"
    }
  }, [_c('b-form-select-option-group', {
    attrs: {
      "label": "驗收週（週五～週四）"
    }
  }, _vm._l(_vm.periods, function (p) {
    return _c('b-form-select-option', {
      key: p.value,
      attrs: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.text))]);
  }), 1), _c('b-form-select-option-group', {
    attrs: {
      "label": "單日"
    }
  }, _vm._l(_vm.daysDesc, function (d) {
    return _c('b-form-select-option', {
      key: d,
      attrs: {
        "value": d + '~' + d
      }
    }, [_vm._v(_vm._s(d))]);
  }), 1)], 1), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.loadRows
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v(" 重新整理 ")])], 1), _c('div', {
    staticClass: "rc_toolbar"
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.LAYERS,
      "buttons": "",
      "button-variant": "outline-secondary",
      "size": "sm"
    },
    model: {
      value: _vm.layer,
      callback: function callback($$v) {
        _vm.layer = $$v;
      },
      expression: "layer"
    }
  }), _c('b-form-checkbox', {
    staticClass: "rc_check",
    model: {
      value: _vm.onlyPush,
      callback: function callback($$v) {
        _vm.onlyPush = $$v;
      },
      expression: "onlyPush"
    }
  }, [_vm._v("僅列推播案件")]), _c('b-form-input', {
    staticClass: "rc_search",
    attrs: {
      "size": "sm",
      "type": "search",
      "placeholder": "搜尋根因、設備或異常編碼"
    },
    model: {
      value: _vm.q,
      callback: function callback($$v) {
        _vm.q = $$v;
      },
      expression: "q"
    }
  })], 1), _vm.error ? _c('b-alert', {
    staticClass: "mx-3",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm.loading && !_vm.rows.length ? _c('b-spinner', {
    staticClass: "mx-3 my-4",
    attrs: {
      "variant": "secondary"
    }
  }) : !_vm.rootOptions.length && !_vm.error ? _c('div', {
    staticClass: "rc_empty"
  }, [_vm._v("尚無每日分析結果。夜間分析首次執行完成後即可查詢。")]) : _vm._e(), _vm.root ? [_c('div', {
    staticClass: "rc_tiles"
  }, _vm._l(_vm.tiles, function (t) {
    return _c('div', {
      key: t.k,
      staticClass: "rc_tile",
      class: t.cls
    }, [_c('div', {
      staticClass: "rc_tileK"
    }, [_vm._v(_vm._s(t.k))]), _c('div', {
      staticClass: "rc_tileV"
    }, [_vm._v(_vm._s(t.v))])]);
  }), 0), _c('div', {
    staticClass: "rc_panel"
  }, [_c('div', {
    staticClass: "rc_panelHead"
  }, [_c('span', {
    staticClass: "rc_panelTitle"
  }, [_vm._v("根因清單")]), _c('span', {
    staticClass: "rc_hint"
  }, [_vm._v("共 " + _vm._s(_vm.filtered.length) + " 筆主告警，依根因歸併為 " + _vm._s(_vm.groups.length) + " 類，依筆數由多至少排列；點選列可展開設備明細。")])]), _c('b-table', {
    staticClass: "rc_table",
    attrs: {
      "items": _vm.groups,
      "fields": _vm.groupFields,
      "small": "",
      "hover": "",
      "show-empty": "",
      "empty-text": "所選期間與篩選條件下無主告警",
      "tbody-tr-class": "rc_row"
    },
    on: {
      "row-clicked": function rowClicked(item) {
        return _vm.$set(item, '_showDetails', !item._showDetails);
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('i', {
          staticClass: "fas fa-chevron-right rc_caret",
          class: {
            open: item._showDetails
          }
        }), _c('b', [_vm._v(_vm._s(item.name))]), _c('span', {
          staticClass: "rc_code"
        }, [_vm._v(_vm._s(item.code))]), _c('div', {
          staticClass: "rc_desc"
        }, [_vm._v(_vm._s(item.desc))])];
      }
    }, {
      key: "cell(layer)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('b-badge', {
          staticClass: "rc_layer",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v(_vm._s(item.layer))])];
      }
    }, {
      key: "cell(push)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.push ? _c('b-badge', {
          staticClass: "rc_badgePush"
        }, [_vm._v("推播 " + _vm._s(item.push))]) : _c('span', {
          staticClass: "rc_muted"
        }, [_vm._v("—")])];
      }
    }, {
      key: "row-details",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "rc_detail"
        }, [_c('dl', {
          staticClass: "rc_dl"
        }, [_c('dt', [_vm._v("可能根因")]), _c('dd', [_vm._v(_vm._s(item.cause || '—'))]), _c('dt', [_vm._v("處置建議")]), _c('dd', [_vm._v(_vm._s(item.action || '—'))]), _c('dt', [_vm._v("判定模組")]), _c('dd', [_vm._v(_vm._s(item.feature || '—'))])]), _c('b-table', {
          staticClass: "rc_devTable",
          attrs: {
            "items": item.devices,
            "fields": _vm.deviceFields,
            "small": ""
          },
          scopedSlots: _vm._u([{
            key: "cell(days)",
            fn: function fn(_ref5) {
              var d = _ref5.item;
              return [_vm._v(" " + _vm._s(d.days) + " 天"), _c('div', {
                staticClass: "rc_muted"
              }, [_vm._v(_vm._s(d.span))])];
            }
          }, {
            key: "cell(value)",
            fn: function fn(_ref6) {
              var d = _ref6.item;
              return [_c('span', {
                staticClass: "rc_num"
              }, [_vm._v(_vm._s(d.value))]), _c('div', {
                staticClass: "rc_muted"
              }, [_vm._v(_vm._s(d.baseKind))])];
            }
          }, {
            key: "cell(push)",
            fn: function fn(_ref7) {
              var d = _ref7.item;
              return [_c('b-badge', {
                class: d.push.cls,
                attrs: {
                  "title": d.pushNote
                }
              }, [_vm._v(_vm._s(d.push.text))])];
            }
          }, {
            key: "cell(links)",
            fn: function fn(_ref8) {
              var d = _ref8.item;
              return [_vm._l(d.links, function (l) {
                return _c('div', {
                  key: l,
                  staticClass: "rc_link"
                }, [_vm._v(_vm._s(l))]);
              }), !d.links.length ? _c('span', {
                staticClass: "rc_muted"
              }, [_vm._v("—")]) : _vm._e()];
            }
          }], null, true)
        })], 1)];
      }
    }], null, false, 3131663552)
  })], 1), _c('div', {
    staticClass: "rc_foot"
  }, [_c('div', [_vm._v("資料來源：夜間分析每日結果（" + _vm._s(_vm.root) + "/每日結果/<日期>/alarms.csv），僅列輸出模式為「告警」之主告警。")]), _c('div', [_vm._v("推播狀態定義：「推播」為當日新發送之推播；「七日內已推播」指同一設備同一異常已於 7 日內推播，依 S-20 不重複發送；「僅顯示」為依案場例外清單僅於報表呈現、不發送推播；「併入全場單」指多台設備同時發生，已合併為全場單一案件（S-21）。")])])] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };